<template>
  <div>
    <div class="enterpriseinfo">
        <div class="enterprise">
            <div class="d-flex">
                <div class="enterpriseinfo-img">
                    <img v-lazy="ImgPreUrl + storeInfo.pic" class="bottom-small"/>
                </div>
                <div class="enterpriseinfo-content">
                    <div class="enterpriseinfo-content-title">
                        <h2>{{storeInfo.title}}</h2>
                        <img v-lazy="'/images/zfxj/icon_'+storeInfo.star+'.png'" :key="storeInfo.state_star" height="15px" v-if="storeInfo.state_star>0"/>
                        <img v-lazy="'/images/xj/icon_'+storeInfo.star+'.png'" :key="storeInfo.star" height="15px" v-else />

                    </div>
                    <!--认证状态-->
                    <div class="enterpriseinfo-verify" :class="{'verify-success':storeInfo.verify==0}">{{ storeInfo.verify | formatVar('verifyType') }}</div> 
                </div>
            </div>
            <!--创建信息-->
            <div class="d-flex enterpriseinfo-create">
                <p><i class="icon-yonghu-tianchong iconfont"></i>创建人：{{storeInfo.create_name?storeInfo.create_name:'系统管理员'}}</p>
                <p><i class="icon-shijian1 iconfont"></i>注册时间：{{storeInfo.time | formatTimestamp(1)}}</p>
                <p><i class="icon-dizhi2 iconfont"></i>注册地址：{{storeInfo.province_name}}省{{storeInfo.city_name}}市{{storeInfo.district_name}}{{storeInfo.address}}</p>
            </div>
        </div>
    </div>
    <!--门店信息-->
    <div class="store">
        <div class="store-title">门店信息</div>
        <!--供应商信息-->
        <supplier-info :storeInfo="storeInfo" :bankcard_arr="bankcard_arr" v-if="type==3"></supplier-info>
        <purchaser-info :storeInfo="storeInfo" v-else></purchaser-info>
    </div>
  </div>
</template>

<script>
import SupplierInfo from './Comps/SupplierInfo'
import PurchaserInfo from './Comps/purchaserInfo'
export default {
  name: 'Enterpriseinfo',
  components: {
    SupplierInfo,
    PurchaserInfo
  },
  props: {
    storeInfo:{
      type:Object,
      default:()=>{}
    },
    type:{
      type:Number,
      default:0
    },
    bankcard_arr:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
 .enterpriseinfo{
    width: 100%;
   box-shadow: 0px 0px 7px #eee;
    background-color: #fff;
    text-align: center;
    border-radius: 6px;
    text-align: left;
    height: 150px;   
 }
 .enterprise{
    padding: 18px;
 }
 .enterpriseinfo-img{
    width: 70px;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f4f8fc;
    border-radius: 50px;
    img{
        width: 100%;
        overflow: hidden;
        border-radius: 6px;
    }
 }
 .enterpriseinfo-content{
    margin-left: 10px;
    h2{
        font-size: 18px;
    }
 }
 .enterpriseinfo-content-title{
    display: flex;
    align-items: center;
    img{
        margin-left: 5px;
        margin-top: 3px;
    }
 }
 .enterpriseinfo-verify{
    background-color: var(--smtc-color-green);
    color: #fff;
    width: 60px;
    text-align: center;
    padding: 4px 0;
    margin-top: 10px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
 }
 .enterpriseinfo-content-time{

    width: 200px;
    padding: 4px 0;
    margin-top: 6px;
    border-radius: 6px;
    font-size: 12px;

    color: #999;
 }
 .enterpriseinfo-create{
    display: flex;
    margin-top: 10px;
    p{
        width: 30%;
        font-size: 14px;
        color: #666;
        i{
            color: #d5d5d5;
            font-size: 14px;
            margin-right: 5px;
        }
    }
    p:nth-child(1){
        width: 25%;
    }
    p:nth-child(3){
        width: 40%;
    }
 }
 .store{
    width: 100%;
    background-color: #fff;
    text-align: center;
    border-radius: 6px;
    text-align: left;
    margin-top: 20px;
    overflow: hidden;  
    box-shadow: 0px 0px 7px #eee;
 }
 .store-title{
    background-color: #f5f7fc;
    width: 100%;
    padding: 18px;
    color: #2e3949;
    font-size: 16px;
    font-weight: bold;
 }
 .flex-padding{
    padding: 18px;
 }
 .verify-success{
    background-color: red;
 }
 .Sales{
    background-color: #f5f7fc;
    margin-left: 6%;
    width: 40px;
    padding: 0 10px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
 }
</style>
